import React from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import "./ProductToolbar.css";

const ProductToolbar = ({ sortBy, onSortChange, productsCount }) => {
  return (
    <div className="product-toolbar">
      <div className="toolbar-tabs">
        <button className="toolbar-tab active">
          Tất cả ({productsCount || 0})
        </button>
      </div>
      <div className="toolbar-sort">
        <label className="sort-label">Sắp xếp:</label>
        <select
          value={sortBy}
          onChange={(e) => onSortChange?.(e.target.value)}
          className="toolbar-sort-select"
        >
          <option value="newest">Tin mới nhất</option>
          <option value="price-asc">Giá thấp đến cao</option>
          <option value="price-desc">Giá cao đến thấp</option>
          <option value="popular">Phổ biến nhất</option>
        </select>
        <ChevronDownIcon className="sort-icon" />
      </div>
    </div>
  );
};

export default ProductToolbar;
